import { eKeHoachThucTapDoanhNghiepActionsObj } from "../../action-types/xet-thuc-tap/IKeHoachThucTapDoanhNghiepActions";
import { generateActions } from "../generateActions";

export const keHoachThucTapDoanhNghiepActions = {
    ...generateActions(eKeHoachThucTapDoanhNghiepActionsObj, "KE_HOACH_THUC_TAP_DOANH_NGHIEP"),
}